import React from 'react'
import CommitmentInfoDisplay from './CommitmentInfoDisplay'
import '../styleSheets/MaterialCommitment.css'
import TextArea from './TextArea'
import CreationInfo from './CreationInfo'
import { bindActionCreators } from 'redux'
import { useDispatch, useSelector} from 'react-redux'

import commitmentSlice from '../../../state/slices/commitmentSlice'
import validatorSlice from '../../../state/slices/validatorSlice'

const BasicInfoContainer = ({ fetchedCommitment, shortDescriptionRef, dateRef, titleRef }) => {

    const { commitment, language, validators } = useSelector((state) => state)
    const dispatch = useDispatch()
    const { changeShortDescValidator } = bindActionCreators(validatorSlice.actions, dispatch)
    const { changeShortDescription } = bindActionCreators(commitmentSlice.actions, dispatch)

    const changeShortDescHandler = (language, content) => {
        changeShortDescription({ language: language, content: content })
    }

    return(
        <div ref={dateRef}>
            <div className="flex-column border-bottom section">
                <CreationInfo
                    fetchedCommitment={fetchedCommitment}
                    dateRef={dateRef}
                />
                <CommitmentInfoDisplay
                    titleRef={titleRef}
                />
                <div ref={shortDescriptionRef}>
                    <TextArea
                        commitment={commitment}
                        target={`shortDescription_${language}`}
                        title={'sit.commitment.shortDescription'}
                        maxLength={400}
                        toolTip={'sit.commitment.shortInfo'}
                        validated={validators.shortDescription}
                        setValidated={() => changeShortDescValidator(true)}
                        handleChange={changeShortDescHandler}
                        language={language}
                    />
                </div>
            </div>
        </div>
    )
}

export default BasicInfoContainer




// WEBPACK FOOTER //
// ./src/components/materialCommitment/commitment/BasicInfoContainer.jsx